<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
</script>
<h2 class="title">TV vs. Digital: Average Time Spent in the US, 2018-2022</h2>
<p class="txt1">hrs:mins per day among population</p>
{#if $media.mobile}
  <svg class="chart" width="341" height="272" viewBox="0 0 341 272" fill="none" xmlns="http://www.w3.org/2000/svg">
    <text class="txt white bold"><tspan x="14.25" y="259.704">2018</tspan></text>
    <text class="txt white bold"><tspan x="85.1953" y="259.704">2019</tspan></text>
    <text class="txt white bold"><tspan x="153.719" y="259.704">2020</tspan></text>
    <text class="txt white bold"><tspan x="225.414" y="259.704">2021</tspan></text>
    <text class="txt white bold"><tspan x="294.19" y="259.704">2022</tspan></text>
    <rect y="20" width="30" height="208" class="red"/>
    <rect x="30" y="140" width="30" height="88" fill="white"/>
    <rect x="70" y="28" width="30" height="200" class="red"/>
    <rect x="100" y="124" width="30" height="104" fill="white"/>
    <rect x="141" y="20" width="30" height="208" class="red"/>
    <rect x="171" y="100" width="30" height="128" fill="white"/>
    <rect x="211" y="36" width="30" height="192" class="red"/>
    <rect x="241" y="92" width="30" height="136" fill="white"/>
    <rect x="281" y="44" width="30" height="184" class="red"/>
    <rect x="311" y="92" width="30" height="136" fill="white"/>
    <text class="txt white small"><tspan x="3.4043" y="12.402">3:42</tspan></text>
    <text class="txt white small"><tspan x="73.7617" y="20.402">3:27</tspan></text>
    <text class="txt white small"><tspan x="144.281" y="12.402">3:34</tspan></text>
    <text class="txt white small"><tspan x="215.412" y="28.402">3:19</tspan></text>
    <text class="txt white small"><tspan x="284.404" y="36.402">3:07</tspan></text>
    <text class="txt white small"><tspan x="35.5547" y="132.402">1:31</tspan></text>
    <text class="txt white small"><tspan x="104.148" y="116.402">1:46</tspan></text>
    <text class="txt white small"><tspan x="175.682" y="92.402">2:13</tspan></text>
    <text class="txt white small"><tspan x="245.506" y="84.402">2:19</tspan></text>
    <text class="txt white small"><tspan x="314.557" y="84.402">2:24</tspan></text>
  </svg>
{:else}
  <svg width="595" height="272" viewBox="0 0 595 272" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="20" width="52.346" height="208" class="red"/>
    <rect x="52.3462" y="140" width="52.346" height="88" fill="white"/>
    <rect x="122.14" y="28" width="52.346" height="200" class="red"/>
    <rect x="174.486" y="124" width="52.346" height="104" fill="white"/>
    <rect x="246.026" y="20" width="52.346" height="208" class="red"/>
    <rect x="298.372" y="100" width="52.346" height="128" fill="white"/>
    <rect x="368.167" y="36" width="52.346" height="192" class="red"/>
    <rect x="420.514" y="92" width="52.346" height="136" fill="white"/>
    <rect x="490.308" y="44" width="52.346" height="184" class="red"/>
    <rect x="542.654" y="92" width="52.346" height="136" fill="white"/>
    <text class="white bold large"><tspan x="34" y="260.376">2018</tspan></text>
    <text class="white bold large"><tspan x="157.886" y="260.376">2019</tspan></text>
    <text class="white bold large"><tspan x="278.026" y="260.376">2020</tspan></text>
    <text class="white bold large"><tspan x="402.167" y="260.376">2021</tspan></text>
    <text class="white bold large"><tspan x="523.308" y="260.376">2022</tspan></text>
    <text class="white"><tspan x="12" y="13.069">3:42</tspan></text>
    <text class="white"><tspan x="135.14" y="21.069">3:27</tspan></text>
    <text class="white"><tspan x="258.026" y="13.069">3:34</tspan></text>
    <text class="white"><tspan x="382.167" y="29.069">3:19</tspan></text>
    <text class="white"><tspan x="502.308" y="37.069">3:07</tspan></text>
    <text class="white"><tspan x="67.3462" y="133.069">1:31</tspan></text>
    <text class="white"><tspan x="187.486" y="117.069">1:46</tspan></text>
    <text class="white"><tspan x="312.372" y="93.069">2:13</tspan></text>
    <text class="white"><tspan x="434.514" y="85.069">2:19</tspan></text>
    <text class="white"><tspan x="555.654" y="85.069">2:24</tspan></text>
</svg>
  
{/if}

<div class="key">
  <div class="key1 item"><div class="block"></div><p class="name">TV</p></div>
  <div class="key2 item"><div class="block"></div><p class="name">Digital Video</p></div>
</div>
<ViewSource id="tv_vs_digital"><a target="_blank" rel="noopener" href="https://www.emarketer.com/chart/243748/tv-vs-digital-video-average-time-spent-us-2018-2022-hrsmins-per-day-among-population">eMarketer, Jan 2021</a></ViewSource>

<style>
  .title {
    margin: 0 0 0.625rem;
  }
  .txt1 {
    margin: 0 0 0.875rem;
  }
  svg {
    margin: 0;
/*     width: 100%;
    height: auto;
    max-width: 400px;
 */  }
  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
  }
  .large {
    font-size: 16px;
  }
  .bold {
    font-weight: bold
  }
  .white {
    fill: white
  }
  .red {
    fill: var(--verizon-red)
  }
  .small {
    font-size: 12px
  }
  .key {
    display: flex;
    font-weight: bold;
    font-size: 14px;
    margin: 10px -10px -10px -10px;
  }
  .key .name {
    margin: 0;
    max-width: 130px
  }
  .key .item {
    display: flex;
    margin: 10px;
  }
  .key .block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transform: translateY(2px)
  }
  .key1 .block {
    background: var(--verizon-red)
  }
  .key2 .block {
    background: white;
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .txt1 {
      margin: 0 0 3rem;
    }
    .key {
      margin-top: 24px;
    }
  }
  
</style>